import { Select, Skeleton, Typography } from 'antd'
import { normalizeDocumentCategories } from 'features/files'
import React, { Dispatch, SetStateAction, useMemo } from 'react'
import styled from 'styled-components'

interface CategorySelectorProps {
  options: ReadonlyArray<string>
  selected: ReadonlyArray<string>
  setSelected: Dispatch<SetStateAction<ReadonlyArray<string>>>
  isLoading?: boolean
}

export function inferCategoryLabel(category: string): string {
  return category
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
}

export const CategorySelector: React.FC<CategorySelectorProps> = ({
  options,
  selected,
  setSelected,
  isLoading = false,
}) => {
  const selectOptions = useMemo(() => {
    const allCategories = [...options, ...selected]
    const normalized = normalizeDocumentCategories(allCategories)

    return normalized.map((category) => ({
      label: inferCategoryLabel(category),
      value: category,
    }))
  }, [options, selected])

  return (
    <Container>
      <Label strong>Categories</Label>
      {isLoading ? (
        <Skeleton active paragraph={{ rows: 1 }} />
      ) : (
        <StyledSelect
          mode='tags'
          value={[...selected]}
          options={selectOptions}
          onChange={(value) =>
            setSelected(() =>
              normalizeDocumentCategories(Array.isArray(value) ? value : [])
            )
          }
          placeholder='Select categories'
          allowClear
        />
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 12px 12px;
  gap: 8px;
`

const Label = styled(Typography.Text)`
  color: ${({ theme }) => theme.forecast.activeText};
`

const StyledSelect = styled(Select)`
  width: 100%;
`
